module.exports = __webpack_public_path__ + "static/img/D4103.47ea73d0.png";